import { Component, DestroyRef, effect, inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserService } from '@services/core/user.service';
import { RequestInsuredService } from '@services/requestInsured.service';
import { PanelComponent } from 'app/components/core-template/panel/panel.component';
import { CoreModule } from 'app/modules/core.module';

@Component({
  selector: 'home',
  templateUrl: './home.html',
  providers: [RequestInsuredService, UserService],
  standalone: true,
  imports: [PanelComponent, CoreModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class HomePage {
  private _requestService: RequestInsuredService = inject(RequestInsuredService)
  private _userService: UserService = inject(UserService)

  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  protected panels: any
  public datePeriod = new Date().toISOString().split('T')[0]

  constructor() {
    effect(() => {
      let user = this._userService.userData()
      if(user) this.getRequest()
    })
  }

  ngOnInit(): void {
    
  }

  getRequest() {
    this._requestService.getDashboard(this.datePeriod).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        this.panels = res.panels
        this.cdr.markForCheck()
      },
      error: (err) => { console.error('Error loading dashboard', err) }
    })
  }
}
